export default "__VITE_ASSET__7f112da6__"